'use strict';
import * as actions from '../actions/notificationsActions';

export const initialState = {
  showButton: false,
  size: 0,
  state: null,
};

/**
 * @param {NotificationsState} state
 * @param {ReduxAction} action
 */
export function notifications(state = initialState, action) {
  switch (action.type) {
    case actions.showButton.TYPE:
      return {
        ...state,
        showButton: true,
      };

    case actions.hideButton.TYPE:
      return {
        ...state,
        showButton: false,
      };

    case actions.updateSize.TYPE:
      return {
        ...state,
        size: action.payload.size,
      };

    case actions.updateState.TYPE:
      return {
        ...state,
        state: action.payload.state,
      };

    default:
      return state;
  }
}

/**
 * @typedef {Object} NotificationsState
 * @property {Boolean} showButton
 * @property {Number} size
 * @property {NoteState} state
 */



// WEBPACK FOOTER //
// ./src/js/system/reducers/notifications.js